import type { DBNotification } from "../types";

/** Unread inbox rows that are still visible (not covered by a first-class card). */
export function getActionableUnreadDbCount(
  inbox: DBNotification[],
  coveredNotifIds: Set<string>,
): number {
  return inbox.filter((n) => !n.is_read && !coveredNotifIds.has(n.id)).length;
}

/** Bell / sheet badge — one count per actionable surface, no double-counting. */
export function getNotificationBadgeCount(
  inbox: DBNotification[],
  coveredNotifIds: Set<string>,
  daysToConfirmCount: number,
  pendingInviteCount: number,
): number {
  return (
    getActionableUnreadDbCount(inbox, coveredNotifIds) +
    daysToConfirmCount +
    pendingInviteCount
  );
}

/** Visible inbox rows across all lanes (including read DB rows). */
export function getVisibleInboxItemCount(
  inbox: DBNotification[],
  coveredNotifIds: Set<string>,
  daysToConfirmCount: number,
  pendingInviteCount: number,
): number {
  const visibleDb = inbox.filter((n) => !coveredNotifIds.has(n.id)).length;
  return pendingInviteCount + daysToConfirmCount + visibleDb;
}
